import { Component } from '@angular/core';

@Component({
    selector: 'providerproductdetailapp',
    template: ` <router-outlet></router-outlet> `,
})
export class ProviderProductDetailComponent {}
